import {SHOW_CLOSE_MODAL_CONFIRMATION, SET_CLOSE_MODAL_CONFIRMATION_CONFIRM_CB} from '../constants/constants'


export const showCloseModalConfirmation = (showModal=false) =>{
    return {
        type: SHOW_CLOSE_MODAL_CONFIRMATION,
        payload: showModal
    }
}

export const setCloseModalConfirmCb = (confirmCb) => {
    return {
        type: SET_CLOSE_MODAL_CONFIRMATION_CONFIRM_CB,
        payload: confirmCb
    }
}
